import { RootState } from "../../rootReducer";

export const selectIsLoading = (state: RootState) => state.fever.loading;
export const feverErrorMessage = (state: RootState) => state.fever.error;
export const feverDataResponse = (state: RootState) =>
  state.fever.feverResponse;
